module.exports = __webpack_public_path__ + "static/partner-2-59a22df0b162758d15a78f7cde6a5e72.png";